'use strict';

import template from './currency_select.html';
import controller from './currency_select.controller';

export default () => {
  return {
    template: template,
    replace: true,
    scope: {
      ngModel: '='
    },
    controllerAs: 'ctrl',
    controller: controller
  };
};



// WEBPACK FOOTER //
// ./app/src/common/currency_select/currency_select.directive.js